// backend restricts announcement/feedback admin endpoints to this role prefix
export const isFullAdmin = (sessionUser) => {
    const roleName = sessionUser && sessionUser.user && sessionUser.user.user_role && sessionUser.user.user_role.role_name;
    return String(roleName || "").startsWith("Admin - Full");
};
